import React from "react"
import { Outlet, useLocation } from "react-router-dom"
import { Sidebar } from "./Sidebar"
import { Header } from "./Header"
import { NoDivisionSelected } from "./NoDivisionSelected"
import { ChatWidget } from "./ChatWidget"
import { ActivityTracker } from "../../features/activity"
import { useUIStore } from "../../stores"
import { cn } from "../../lib/utils"

export function DashboardLayout() {
  const { sidebarCollapsed, mobileMenuOpen, setMobileMenuOpen, selectedDivision } = useUIStore()
  const location = useLocation()

  // Check if we're on a page that needs full-height layout (no padding)
  // Match when the segment after /matters/ is a MongoDB ObjectID (24 hex) or numeric ID
  const isMatterDetail = /^\/matters\/([a-f0-9]{24}|\d+)(\/|$)/i.test(location.pathname)
  const isTextsPage = location.pathname.startsWith("/texts")
  const isFullHeightPage = isMatterDetail || isTextsPage

  return (
    <div className="flex h-screen overflow-hidden bg-muted">
      {/* Activity Tracker - monitors user interactions */}
      <ActivityTracker />

      {/* Mobile/Tablet backdrop */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-[199] lg:hidden"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      {/* Sidebar */}
      <Sidebar />

      {/* Main content area */}
      <div
        className={cn(
          "flex flex-1 flex-col overflow-hidden transition-all duration-300",
          // Mobile/Tablet: no margin (sidebar overlays)
          "ml-0",
          // Desktop: respect collapse state
          sidebarCollapsed ? "lg:ml-16" : "lg:ml-[200px]"
        )}
      >
        {/* Header */}
        <Header />

        {/* Page content */}
        <main className={cn("flex-1 overflow-auto bg-muted relative", !isFullHeightPage && "p-4", "pb-24")}>
          {selectedDivision ? <Outlet /> : <NoDivisionSelected />}
        </main>
      </div>

      {/* Chat widget */}
      <ChatWidget />
    </div>
  )
}
